export default "__VITE_ASSET__3aeffead__"